// Get settings from theme (passed from Liquid)
const popupSettings = window.locationPopupSettings || {
  enabled: true,
  delay: 3000,
  testMode: false,
  buttonLink: '/collections/all',
  closeOnOverlay: true
};

// Function to get visitor's country using IP geolocation
async function getVisitorCountry() {
  try {
    // Using ipapi.co free service (no API key needed for basic usage)
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    return data.country_name || 'Your Location';
  } catch (error) {
    console.error('Error fetching location:', error);
    // Fallback to browser's language/locale
    const locale = navigator.language || navigator.userLanguage;
    const countryCode = locale.split('-')[1];
    return countryCode ? getCountryName(countryCode) : 'Your Location';
  }
}

// Helper function to get country name from code
function getCountryName(code) {
  const countries = {
    'US': 'United States',
    'GB': 'United Kingdom',
    'CA': 'Canada',
    'AU': 'Australia',
    'IL': 'Israel',
    'FR': 'France',
    'DE': 'Germany',
    'ES': 'Spain',
    'IT': 'Italy',
    'NL': 'Netherlands',
    'SE': 'Sweden',
    'NO': 'Norway',
    'DK': 'Denmark',
    'FI': 'Finland',
    'JP': 'Japan',
    'CN': 'China',
    'IN': 'India',
    'BR': 'Brazil',
    'MX': 'Mexico',
    'NZ': 'New Zealand',
    // Add more country codes as needed
  };
  return countries[code] || code;
}

// Determine currency based on country
function getCurrencyByCountry(countryName) {
  if (!countryName) return 'EUR';
  
  const normalized = String(countryName).toLowerCase();
  
  // Define country to currency mapping
  if (normalized === 'israel') return 'ILS';
  if (normalized === 'united states') return 'USD';
  if (normalized === 'canada') return 'CAD';
  if (normalized === 'united kingdom') return 'GBP';
  if (normalized === 'australia') return 'AUD';
  if (normalized === 'japan') return 'JPY';
  
  // Default to EUR for European countries and others
  return 'EUR';
}

// Function to show the pop-up
async function showLocationPopup() {
  // Check if popup is enabled in settings
  if (!popupSettings.enabled) {
    console.log('Location popup is disabled');
    return;
  }

  // Check if user has already seen the popup (skip this check in test mode)
  if (!popupSettings.testMode && localStorage.getItem('locationPopupShown') === 'true') {
    console.log('Popup already shown to this visitor');
    return;
  }

  // Get visitor's country
  const country = await getVisitorCountry();
  
  // Get appropriate currency for the country
  const currency = getCurrencyByCountry(country);
  
  console.log(`Detected location: ${country}, Display currency: ${currency}`);
  
  // Update country in the popup
  const countryElement = document.getElementById('visitor-country');
  if (countryElement) {
    countryElement.textContent = country;
  }
  
  // Update currency text in description lines
  // Look for any text containing 'EUR' and replace with appropriate currency
  const descriptionLines = document.querySelectorAll('.popup-desc-line');
  descriptionLines.forEach(element => {
    const originalText = element.getAttribute('data-original-text') || element.textContent;
    if (originalText.includes('EUR')) {
      element.textContent = originalText.replace(/EUR/g, currency);
    }
  });
  
  // Save detected country and currency
  try { 
    localStorage.setItem('detectedCountry', country);
    localStorage.setItem('displayCurrency', currency);
  } catch (e) {
    console.error('Error saving to localStorage:', e);
  }

  // Show the popup after configured delay
  const delay = popupSettings.delay || 3000;
  console.log(`Showing popup in ${delay/1000} seconds...`);
  
  setTimeout(function() {
    const popupOverlay = document.getElementById('location-popup-overlay');
    if (popupOverlay) {
      popupOverlay.style.display = 'block';
      
      // Mark popup as shown (unless in test mode)
      if (!popupSettings.testMode) {
        localStorage.setItem('locationPopupShown', 'true');
      }
      
      console.log('Location popup displayed');
    }
  }, delay);
}

// Function to close the pop-up
function closeLocationPopup() {
  const popupOverlay = document.getElementById('location-popup-overlay');
  if (popupOverlay) {
    popupOverlay.style.display = 'none';
    console.log('Location popup closed');
  }
}

// Function for Shop Now button
function shopNow() {
  const url = popupSettings.buttonLink || '/collections/all';
  console.log('Redirecting to:', url);
  window.location.href = url;
  closeLocationPopup();
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Only proceed if popup is enabled
  if (!popupSettings.enabled) {
    return;
  }
  
  // Close popup when clicking outside (if enabled in settings)
  const popupOverlay = document.getElementById('location-popup-overlay');
  if (popupOverlay && popupSettings.closeOnOverlay) {
    popupOverlay.addEventListener('click', function(event) {
      if (event.target === this) {
        closeLocationPopup();
      }
    });
  }
  
  // Show the popup
  showLocationPopup();
});

// Utility functions for testing
function resetLocationPopup() {
  localStorage.removeItem('locationPopupShown');
  localStorage.removeItem('detectedCountry');
  localStorage.removeItem('displayCurrency');
  console.log('Location popup reset. Refresh the page to see it again.');
}

// Admin utilities (useful for testing from console)
window.locationPopupUtils = {
  reset: resetLocationPopup,
  forceShow: () => {
    localStorage.removeItem('locationPopupShown');
    showLocationPopup();
  },
  getSettings: () => popupSettings,
  getStatus: () => ({
    enabled: popupSettings.enabled,
    shown: localStorage.getItem('locationPopupShown'),
    country: localStorage.getItem('detectedCountry'),
    currency: localStorage.getItem('displayCurrency'),
    testMode: popupSettings.testMode
  })
};

// Make functions globally available
window.closeLocationPopup = closeLocationPopup;
window.shopNow = shopNow;
window.resetLocationPopup = resetLocationPopup;